/**
 * Converts nested JSON schema errors from the API into a readable format.
 *
 * @param {Object} body  The body of the response
 * @returns {Object}  The extracted schema errors
 */
export function extractSchemaError(body) {
  const fields = body?.messages?.json
  if (!fields) return {}

  const pretty = Object.entries(fields)
    .flatMap(([field, msgs]) =>
      msgs.map(
        m =>
          `${field.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())}: ${m}`,
      ),
    )
    .join('\n')

  return { fields, pretty }
}
